export default __webpack_public_path__ + "static/media/Rectangle 2.bb9407ee.svg";